<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 27.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<path id="Path_358" style="fill:#5FB546;" d="M18.9,7.1c-0.3-0.3-0.9-0.3-1.2,0l-7.8,7.8l-3.4-3.4c-0.3-0.3-0.9-0.3-1.2,0
	c-0.3,0.3-0.3,0.9,0,1.2l4.6,4.7l9-9C19.2,8,19.2,7.4,18.9,7.1C18.9,7.1,18.9,7.1,18.9,7.1z"/>
</svg>
